package team.platforma.aicombo.activity.auth.component.fragment.password_restore

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.arrow_left
import aicombo.composeapp.generated.resources.cross_m
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.viewmodel.koinViewModel
import team.platforma.aicombo.activity.main.MainApp
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.colors.getOutlinedTextColors
import team.platforma.auth_presentable.viewModel.AuthViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.navigator.activity.findNavHost
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.text_input.TextInput

object RestorePasswordFragment : Fragment(
    route = "create_new_password_route",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        val auth = koinViewModel<AuthViewModel>()

        val keyboardHeight by rememberKeyboardHeight()
        var showLoader by remember { mutableStateOf(false) }

        val email by remember { mutableStateOf("") }

        var password by remember { mutableStateOf("") }
        val validInput by produceState(initialValue = false, password) {
            value = checkValid(password)
        }

        var repeatedPassword by remember { mutableStateOf("") }
        val repeatedValidInput by produceState(initialValue = false, repeatedPassword) {
            value = checkValid(repeatedPassword) && repeatedPassword == password
        }
        Box(modifier = Modifier.fillMaxSize()) {
            Scaffold(modifier = Modifier.fillMaxHeight().widthIn(max = 533.dp)
                .align(Alignment.Center),
                topBar = {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .background(color = AppColors.bg.base().default)
                            .heightIn(min = 64.dp).clickable {
                                fragmentNavigator.navigateBack()
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Spacer(modifier = Modifier.width(16.dp))
                        Icon(
                            painter = painterResource(Res.drawable.arrow_left),
                            contentDescription = null,
                            tint = AppColors.text().default,
                            modifier = Modifier.size(24.dp)
                        )
                        Text("Восстановление пароля")
                        Spacer(modifier = Modifier.width(16.dp))
                    }
                }) { pV ->
                Box(modifier = Modifier.fillMaxSize().padding(pV)) {
                    Column(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
                        Text("Придумайте пароль")

                        TextInput(
                            value = password,
                            onValueChange = {
                                password = it
                            },
                            modifier = Modifier.fillMaxWidth(),
                            label = {
                                Text(
                                    text = "Пароль"
                                )
                            },
                            placeholder = {
                                Text(
                                    text = "Создайте пароль"
                                )
                            },
                            trailingIcon = {
                                if (password.isNotEmpty()) {
                                    IconButton(
                                        onClick = {
                                            password = ""
                                        }
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.cross_m),
                                            contentDescription = null
                                        )
                                    }
                                }
                            },
                            keyboardOptions = KeyboardOptions.Default.copy(
                                keyboardType = KeyboardType.Email,
                                hintLocales = LocaleList(Locale("en")),
                                imeAction = ImeAction.Next
                            ),
                            colors = getOutlinedTextColors()
                        )
                        Spacer(modifier = Modifier.height(8.dp))
                        TextInput(
                            value = repeatedPassword,
                            onValueChange = {
                                repeatedPassword = it
                            },
                            modifier = Modifier.fillMaxWidth(),
                            label = {
                                Text(
                                    text = "Повторите пароль"
                                )
                            },
                            placeholder = {
                                Text(
                                    text = "Повторите созданный пароль"
                                )
                            },
                            trailingIcon = {
                                if (repeatedPassword.isNotEmpty()) {
                                    IconButton(
                                        onClick = {
                                            repeatedPassword = ""
                                        }
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.cross_m),
                                            contentDescription = null
                                        )
                                    }
                                }
                            },
                            keyboardOptions = KeyboardOptions.Default.copy(
                                keyboardType = KeyboardType.Email,
                                hintLocales = LocaleList(Locale("en")),
                                imeAction = ImeAction.Next
                            ),
                            colors = getOutlinedTextColors()
                        )

                        Spacer(modifier = Modifier.weight(1f))

                        AppFilledButton(
                            onClick = {
                                auth.signIn(
                                    email = email,
                                    password = password,
                                    onSuccess = {
                                        showLoader = false
                                        findNavHost().navigateToActivity(MainApp)
                                    },
                                    onError = {
                                        showLoader = false
                                    }
                                )
                            },
                            enabled = validInput && email != null && repeatedValidInput,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text(
                                text = "Продолжить"
                            )
                        }

                        AppFilledButton(
                            onClick = {
                                //To restore password
                            },
                            enabled = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.buttonColors().copy(
                                contentColor = AppColors.text().primary,
                                containerColor = Color.Transparent
                            )
                        ) {
                            Text(
                                text = "Если возникли вопросы - Напишите команде проекта"
                            )
                        }
                        Spacer(
                            modifier = Modifier.height(keyboardHeight)
                        )
                    }
                }
            }
        }
    }
)

private fun checkValid(password: String): Boolean {

    val passwordRegex = Regex("^[a-zA-Z0-9!@#$%^&*(),.?\":{}|<>_\\-+=/\\\\~`]*$")

    return password.length >= 6 && passwordRegex.matches(password)
}